class PooltimeSearch {
  constructor(root) {
    this.root = root;
    this.input = root.querySelector('[data-pt-search-input]');
    this.panel = root.querySelector('[data-pt-search-panel]');
    this.results = root.querySelector('[data-pt-search-results]');
    this.closeButtons = root.querySelectorAll('[data-pt-search-close]');
    this.clearButton = root.querySelector('[data-pt-search-clear]');

    this.abortController = null;
    this.timer = null;
    this.cache = new Map();

    if (!this.input || !this.panel || !this.results) return;

    this.input.addEventListener('focus', () => {
      this.open();

      if (this.input.value.trim().length >= 2) {
        this.search();
      }
    });

    this.input.addEventListener('input', () => {
      clearTimeout(this.timer);

      const term = this.input.value.trim();

      if (term.length < 2) {
        this.results.innerHTML = '';
        this.panel.classList.remove('has-results');
        this.root.classList.remove('is-loading');
        return;
      }

      this.timer = setTimeout(() => {
        this.search();
      }, 180);
    });

    if (this.clearButton) {
      this.clearButton.addEventListener('click', () => {
        this.input.value = '';
        this.results.innerHTML = '';
        this.panel.classList.remove('has-results');
        this.root.classList.remove('is-loading');
        this.input.focus();
      });
    }

    this.closeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        this.close();
      });
    });

    document.addEventListener('keydown', (event) => {
      if (
        event.key === 'Escape' &&
        this.root.classList.contains('is-open')
      ) {
        this.close();
      }
    });
  }

  open() {
    this.root.classList.add('is-open');
    document.documentElement.classList.add('pt-search-open');
  }

  close() {
  this.root.classList.remove('is-open');
  this.panel.classList.remove('has-results');
  document.documentElement.classList.remove('pt-search-open');

  const details = this.root.closest('details');

  if (details && details.hasAttribute('open')) {
    details.removeAttribute('open');
  }
}

  async search() {
    const term = this.input.value.trim();

    if (term.length < 2) return;

    this.open();
    this.root.classList.add('is-loading');

    if (this.cache.has(term)) {
      this.render(this.cache.get(term));
      return;
    }

    if (this.abortController) {
      this.abortController.abort();
    }

    this.abortController = new AbortController();

    const baseUrl =
      window.routes && window.routes.predictive_search_url
        ? window.routes.predictive_search_url
        : '/search/suggest';

    const params = new URLSearchParams();

    params.set('q', term);
    params.set(
      'resources[type]',
      'query,product,collection,page,article'
    );
    params.set('resources[limit]', '10');
    params.set(
      'resources[options][unavailable_products]',
      'last'
    );
    params.set(
      'resources[options][fields]',
      'title,product_type,variants.title,vendor'
    );
    params.set(
      'section_id',
      'pooltime-predictive-search'
    );

    const url = `${baseUrl}?${params.toString()}`;

    try {
      const response = await fetch(url, {
        signal: this.abortController.signal,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error(
          `Pooltime search failed: ${response.status}`
        );
      }

      const html = await response.text();

      const documentResult =
        new DOMParser().parseFromString(
          html,
          'text/html'
        );

      const content =
        documentResult.querySelector(
          '#PooltimePredictiveResults'
        );

      const markup = content
        ? content.outerHTML
        : '';

      this.cache.set(term, markup);

      this.render(markup);
    } catch (error) {
      if (error.name === 'AbortError') return;

      console.error(
        'Pooltime predictive search:',
        error
      );

      this.results.innerHTML = `
        <div class="pt-search-error">
          Sökningen kunde inte laddas.
          Försök igen.
        </div>
      `;
    } finally {
      this.root.classList.remove('is-loading');
    }
  }

  render(markup) {
    this.results.innerHTML = markup;

    this.panel.classList.add('has-results');
    this.root.classList.add('is-open');
    this.root.classList.remove('is-loading');

    document.documentElement.classList.add(
      'pt-search-open'
    );
  }
}

function initPooltimeSearch() {
  document
    .querySelectorAll('[data-pooltime-search]')
    .forEach((element) => {
      if (element.dataset.pooltimeSearchInit === 'true') {
        return;
      }

      element.dataset.pooltimeSearchInit = 'true';

      new PooltimeSearch(element);
    });
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    initPooltimeSearch
  );
} else {
  initPooltimeSearch();
}

document.addEventListener(
  'shopify:section:load',
  initPooltimeSearch
);